import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=2a8f8f2c&scoped=true&"
import script from "./Billboard.vue?vue&type=script&lang=ts&"
export * from "./Billboard.vue?vue&type=script&lang=ts&"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=2a8f8f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f8f2c",
  null
  
)

export default component.exports